import type { Person } from '../entities/person.js';

/** The two ways a person is linked to a child. Both are stored on the parent, as an array of child ids. */
export type FamilyLink = 'sorgeberechtigt' | 'spender';

export const FAMILY_LINK_FIELDS = {
  sorgeberechtigt: 'sorgeberechtigteKinderIDs',
  spender: 'spendenKinderIDs',
} as const satisfies Record<FamilyLink, keyof Person>;

export const ALL_FAMILY_LINKS: FamilyLink[] = ['sorgeberechtigt', 'spender'];
